export default {
  init() {
    // JavaScript to be fired on the videos page
    $(document).on('click', '.video-modal a', function(e) {
      e.preventDefault();
      const video = $(this).attr('href');
      $.magnificPopup.open({
        items: {
          src: video,
        },
        type: 'iframe',
        midClick: true,
        mainClass: 'mfp-fade',
      });
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/videos.js